import type { Option } from '../../index';

export const getOptions = (options: Option[], value: number[], selections?: number[]) => {
  if (value) {
    const selectedOptions = options.filter((x) => value.indexOf(x.value as number) !== -1);
    if (selections && selections.length > 0) {
      const selectionsOptions = options.filter((x) => selections.indexOf(x.value as number) !== -1);
      return selectionsOptions;
    }
    return selectedOptions;
  }
  return [];
};

export const parseAddLabel = (val: string) => parseInt(val.replace('(', '').replace(')', ''), 10);
